import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const NONE = "__none";
const cache = {};

export function invalidateEntity(endpoint) {
  Object.keys(cache).filter((k) => k.startsWith(endpoint)).forEach((k) => delete cache[k]);
}

async function loadOptions(endpoint, params) {
  const key = endpoint + JSON.stringify(params || {});
  if (!cache[key]) {
    cache[key] = api.get(endpoint, { params }).then((r) => (Array.isArray(r.data) ? r.data : r.data.items));
    cache[key].catch(() => delete cache[key]);
  }
  return cache[key];
}

export function EntitySelect({ endpoint, params, value, onChange, labelKey = "name", placeholder = "Seçiniz", allowEmpty = true, testId }) {
  const [opts, setOpts] = useState([]);
  const pkey = JSON.stringify(params || {});
  useEffect(() => {
    loadOptions(endpoint, params).then(setOpts).catch(() => setOpts([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, pkey]);
  const label = (o) => (typeof labelKey === "function" ? labelKey(o) : o[labelKey]);
  return (
    <Select value={value || (allowEmpty ? NONE : "")} onValueChange={(v) => onChange(v === NONE ? null : v)}>
      <SelectTrigger data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        {allowEmpty && <SelectItem value={NONE}>— {placeholder} —</SelectItem>}
        {opts.map((o) => <SelectItem key={o.id} value={o.id}>{label(o)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
